import { render, staticRenderFns } from "./CountryList.vue?vue&type=template&id=2f10c8d0&scoped=true"
import script from "./CountryList.vue?vue&type=script&lang=js"
export * from "./CountryList.vue?vue&type=script&lang=js"
import style0 from "./CountryList.vue?vue&type=style&index=0&id=2f10c8d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f10c8d0",
  null
  
)

export default component.exports